module.exports = __webpack_public_path__ + "media/theme/border-8-46b1900e.png";